export * from './equipment-detail.component';
export * from './equipment-detail.service';
// export * from './equipment-update-status.service';



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/equipment/equipment-detail/index.ts